const filterRosterItems = (input) => {
  const page = input.closest('.hotsite-roster-page');
  if (!page) return;

  const list = page.querySelector('[data-roster-list]');
  if (!list) return;

  const query = input.value.trim().toLowerCase();
  const items = list.querySelectorAll('[data-roster-item]');

  items.forEach((item) => {
    const searchText = item.dataset.rosterSearchText || '';
    const matches = query === '' || searchText.includes(query);
    item.classList.toggle('d-none', !matches);
  });
};

const initRosterSearch = () => {
  document.querySelectorAll('[data-roster-search]').forEach((input) => {
    if (input.dataset.rosterSearchInitialized === 'true') return;

    input.dataset.rosterSearchInitialized = 'true';
    input.addEventListener('input', () => filterRosterItems(input));
  });
};

document.addEventListener('turbolinks:load', initRosterSearch);
document.addEventListener('DOMContentLoaded', initRosterSearch);
